<template>
  <Layout>
    <div class="mc-report__delivery-load">
      <PageHeader :title="title">
        <template #afterTitle>
          <div class="d-flex align-items-center gap-2">
            <McListDownloader
              :pageOptions="downloadPageOptions"
              :fileFormatOptions="['excel']"
              @download="handleDownload"
            />
            <McButtonBack />
          </div>
        </template>
      </PageHeader>
      <McTable
        withCard
        searchable
        :fields="fields"
        :apiClient="apiClient"
        :hasCheckbox="false"
        hasViewManager
      >
        <template #cell()="{ field, value }">
          {{ formatValues(value) }}
        </template>
      </McTable>
    </div>
  </Layout>
</template>

<script>
import appConfig from '@/app.config'
import { mapGetters } from 'vuex'

import Layout from '@/router/layouts/main'
import PageHeader from '@/components/page-header-v2'
import McButtonBack from '@/components/McButtonBack'
import McTable from '@/components/McTable'
import McListDownloader from '@/components/McListDownloader'

import * as Report from '@/services/rest-api/lib/report/report.js'
import fields from './lib/fields/fields'
import omitBy from 'lodash/omitBy'
import { formatNumber } from '@/helpers/format-number.js'

export default {
  page: {
    title: 'Report Delivery Load',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: {
    Layout,
    PageHeader,
    McButtonBack,
    McTable,
    McListDownloader,
  },
  data() {
    return {
      params: {},
      metadata: null,
    }
  },
  computed: {
    ...mapGetters({
      getFeatureFlagValue: 'identity/getFeatureFlagValue',
    }),
    title() {
      return 'Riwayat Muatan'
    },
    fields() {
      const computedFields = []

      fields().forEach((field) => {
        if (!field.isShow) return

        computedFields.push(field)
      })
      return computedFields
    },
    downloadPageOptions() {
      return [
        { label: this.$t('global.currentPage'), amount: this.metadata?.count, key: 'current_page' },
        { label: this.$t('global.allPages'), amount: this.metadata?.total_count, key: 'all' },
      ]
    },
    apiClient() {
      return {
        get: Report.getReportDeliveryLoad(this.handleSetParams, this.handleSetMetadata),
      }
    },
  },
  methods: {
    handleDownload(format, dataAmount) {
      // Remove undefined params
      const params = omitBy(
        {
          ...this.params,
          format,
        },
        (value) => value === undefined
      )

      if (dataAmount === 'all') {
        delete params['limit']
        delete params['page']
      }

      window.open(
        `${process.env.VUE_APP_API_ORDER_URL}/report/2?${new URLSearchParams(params).toString()}`,
        '_self'
      )
    },
    handleSetParams(params) {
      this.params = params
    },
    handleSetMetadata(metadata) {
      this.metadata = metadata
    },
    formatValues(value) {
      if (typeof value == 'number') {
        return formatNumber(value, 3) || '-'
      }

      return value || '-'
    },
  },
}
</script>
